module.exports = __webpack_public_path__ + "static/9-6cb5601a5f62affc33b1426230ef38cd.jpg";